import { ClientCustomization } from './client-customization';
import { Corporate } from './corporate';

export class ClientSSO {
  constructor(
    clientSSO?: ClientSSO,
    public nameTranslations?: any,
    public id: string = null,
    public name: string = null,
    public alias: string = null,
    public hasSingleSignOn: boolean = false,
    public loginUrl: string = null,
    public defaultLanguageId: number = null,
    public languageIds: number[] = null,
    public corporate: Corporate = null,
    public supportEmail: string = null,
    public customization: ClientCustomization = null,
    public ssoAccessOnly: boolean = false,
    public b2CAccessOnly: boolean = false,
    public b2CDomainHint: string = ''
  ) {
    Object.assign(this, clientSSO);
    this.customization = new ClientCustomization(this.customization);
  }

  isCustomizationDefined(): boolean {
    return !!this.customization;
  }
}
